import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const emiFAQs = [
  {
    question: "What is EMI and how is it calculated?",
    answer: "EMI (Equated Monthly Installment) is the fixed payment amount you make to the lender each month. For reducing balance loans, it's calculated using the formula: EMI = P × r × (1+r)^n / ((1+r)^n - 1), where P is principal, r is monthly interest rate, and n is total number of months. The EMI remains constant throughout the loan tenure, but the proportion of principal and interest changes each month."
  },
  {
    question: "What's the difference between Reducing Balance and Flat Rate interest?",
    answer: "In Reducing Balance (or Diminishing Balance), interest is calculated on the outstanding principal balance, which decreases with each EMI payment. This results in lower total interest paid. In Flat Rate, interest is calculated on the original principal throughout the tenure, resulting in higher total interest. Most home loans use reducing balance, while some personal loans use flat rate."
  },
  {
    question: "How does prepayment affect my EMI?",
    answer: "Prepayment reduces your outstanding principal, which can either reduce your EMI amount while keeping the tenure same, or reduce your loan tenure while keeping EMI same. Either way, you save on total interest paid. Most floating rate home loans in India don't charge prepayment penalties as per RBI guidelines."
  },
  {
    question: "What factors affect my EMI amount?",
    answer: "Three main factors affect your EMI: 1) Principal loan amount - higher principal means higher EMI, 2) Interest rate - higher rate increases EMI, 3) Loan tenure - longer tenure reduces EMI but increases total interest paid. Additionally, the type of interest calculation (reducing vs flat) also impacts your effective EMI."
  },
  {
    question: "Should I choose a longer or shorter loan tenure?",
    answer: "A shorter tenure means higher EMIs but significantly less total interest paid. A longer tenure means lower EMIs (more affordable monthly payments) but higher total interest. Choose based on your monthly budget and financial goals. If you can afford higher EMIs, a shorter tenure saves money in the long run."
  },
  {
    question: "How accurate is this EMI calculator?",
    answer: "This calculator provides accurate estimates based on standard EMI formulas. However, actual EMIs may vary slightly due to: 1) Processing fees and other charges, 2) Date of disbursement affecting first EMI, 3) Rounding conventions used by lenders, 4) Variable interest rate fluctuations. Use this as a planning tool and confirm exact figures with your lender."
  }
];

export function EMIFAQ() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      id="faq"
      className="py-6 lg:py-8"
    >
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-foreground mb-2">
          Frequently Asked Questions
        </h2>
        <p className="text-muted-foreground">
          Everything you need to know about EMI, loans, and smart borrowing
        </p>
      </div>

      <Accordion type="single" collapsible className="space-y-2">
        {emiFAQs.map((faq, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="border-b border-border/50 px-0 data-[state=open]:bg-transparent transition-colors"
          >
            <AccordionTrigger className="text-left font-medium text-foreground hover:text-primary hover:no-underline py-4">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground pb-4 leading-relaxed">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.section>
  );
}
